import { useCallback } from "react";
import { useGetList, useInput, type CommonInputProps } from "react-admin";
import { useFormContext } from "react-hook-form";

import { RolesTable } from "@/components/RolesTable";
import { type RoleEntity } from "@/modules/roles/types";

export const RolesTableInput = ({
  onBlur,
  onChange,
  ...rest
}: CommonInputProps) => {
  const { isLoading, data } = useGetList<RoleEntity>("roles");
  const { getValues } = useFormContext();
  const { field } = useInput({
    onBlur,
    onChange,
    ...rest,
  });
  const onChangeFormField = field.onChange;

  const handleChange = useCallback(
    (ruleToChange: string, isChecked: boolean) => {
      const formValues = getValues() as Record<string, string[] | undefined>;
      const currentValues = formValues[rest.source] ?? [];
      const newRules = new Set<string>(currentValues);

      if (isChecked) {
        newRules.add(ruleToChange);
      } else {
        newRules.delete(ruleToChange);
      }

      onChangeFormField([...newRules.values()]);
    },
    [getValues, onChangeFormField, rest.source],
  );

  const fieldValue = (field.value as string[] | undefined) ?? [];

  return (
    <RolesTable
      rules={fieldValue}
      entities={data ?? []}
      isLoading={isLoading}
      onChange={handleChange}
    />
  );
};
